import './App.css';

import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import axios_sender from './modules/axios_sender';

import Authorize from './Authorize/Authorize.js';
import PageMain from './PageMain/PageMain.js';

import {ThemeProvider} from "./ThemeContext.js";



function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  //const themeContext = React.useContext(ThemeContext);
  
  useEffect(() => { 
    GetAuthentification()
    }, []);

  function GetAuthentification()
  {
    axios_sender({form: 'is_user'}, GetAuthentificationSuccess);
  }
  function GetAuthentificationSuccess(data)
  {
    setIsAuthenticated(data);
  }


  


return (
  
        isAuthenticated ? (
        
        <ThemeProvider>
          <PageMain onOutAuthorize={setIsAuthenticated}/>        
        </ThemeProvider>
        
        ) : (

            <div className="App">
              <BrowserRouter> 
                <Routes>
                  <Route path="*" element={<Authorize onAuthorize={setIsAuthenticated} />} />
                </Routes>
              </BrowserRouter>          
            </div>    
        )       
      );        
}

export default App;
